export * from './CustomizationDetailsDressingWeight';
